// extracted by mini-css-extract-plugin
module.exports = {"navi":"EmployeeEditingForm__navi--1lXVZ","form":"EmployeeEditingForm__form--3fKiX"};